import { memo } from 'react';
import * as S from './ChooseAppOrWebsite.styled';
import { ImageWithFallback } from 'components';
import { subdirectory } from 'utils';

const SelectedApp = ({ environment, image_url, pba_name, pba_url1 }) => {
  return (
    <S.SelectedApp environment={environment}>
      <S.AppInfo>
        <S.ImgInfo>
          <ImageWithFallback
            src={`https://cdn.appnext.com/${subdirectory(image_url)}/${image_url}`}
          />
        </S.ImgInfo>
        <S.AppName>
          <S.AppNameText>{pba_name}</S.AppNameText>
          <S.PackageName>{pba_url1}</S.PackageName>
        </S.AppName>
      </S.AppInfo>
    </S.SelectedApp>
  );
};

export default memo(SelectedApp);
